import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../../Controls/TextBoxControl"
import GridControl from "../../../../Controls/GridControl"
import Accordion from 'react-bootstrap/Accordion';
import ShowOwnerResidentialInfo from "../../../../Controls/ShowOwnerResidentialInfo"
import ShowFilesReviewAbstractList from "../../../../Controls/ShowFilesReviewAbstractList"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import { 
	GetLocal,
	FetchService,
	Base64Type
} from "../../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../../Base/BasePageEmployee';

export default function Index(props) {
	const [getServiceResult, setServiceResult] = useState(false); 
	
    useEffect(() => {
        var inputValue = {
             session: GetLocal('EmployeeSession'),
			 requestNumber: GetLocal('RequestNumber')
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowOrderMapReview", inputValue, ShowOrderMapReviewSuccess);
    }, []);	
	
    const ShowOrderMapReviewSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult);
    }		
	
    return (
        <div> 
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')}/>
			<ShowFilesReviewAbstractList/>
			{getServiceResult ? <div>	 
			<Accordion>
			  <Accordion.Item eventKey="0">
				<Accordion.Header>اطلاعات نقشه</Accordion.Header>
				<Accordion.Body>
					<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>					
						<tbody>
							<tr>
								<td><b class="b1">کسری پارکینگ:</b> {getServiceResult.DeficitsParkingCount}</td>
								<td><b class="b1">مقدار تراکم مازاد:</b> {getServiceResult.Density}</td>
								<td><b class="b1">مساحت مورد توسعه:</b> {getServiceResult.AreaDevelopment}</td>
							</tr>
							<tr>	
								<td><b class="b1">طبقات زیر زمین:</b> {getServiceResult.BasementFloorCount}</td>
								<td><b class="b1">تعداد طبقات سایر:</b> {getServiceResult.FloorCount}</td>
								<td><b class="b1">تعداد کل طبقات:</b> {getServiceResult.TotalFloorCount}</td>
							</tr>
							<tr>	
								<td><b class="b1">گروه صرفه جویی انرژی:</b> {getServiceResult.FrugalityGroup}</td>
								<td><b class="b1">نوع اسکلت:</b> {getServiceResult.BuildingStructuresTitle}</td>
								<td><b class="b1">نوع پروانه:</b> {getServiceResult.DocumentTitle}</td>
							</tr>
							<tr>	
								<td><b class="b1">مصالح ساختمانی:</b> {getServiceResult.BuildingMaterialsTitle}</td>
								<td><b class="b1">نوع نمای ساختمان:</b> {getServiceResult.FacadeTitle}</td>
								<td><b class="b1">نوع سقف:</b> {getServiceResult.RoofTitle}</td>
							</tr>
							<tr>	
								<td colspan="3"><b class="b1">توضیح نقشه:</b> {getServiceResult.MapDescription}</td>
							</tr>	
						</tbody>
					</table>

					<Tabs defaultActiveKey="infoMap" className="mb-3" >
						<Tab eventKey="infoMap" title="اطلاعات جانبی نقشه">
							<GridControl
								data={Object.keys(getServiceResult).length > 0 && getServiceResult.ReusedMapInfoList.map((item, index) => ({ ...item, ID: index + 1 }))}
								customHeaders={{
									"ID": "ردیف",
									"ReusedUsageTitle": "نوع تبدیل",
									"ReusedUsageArea": "مساحت"
								}}		
							/>								
							<br/>	
							<GridControl
								data={Object.keys(getServiceResult).length > 0 && getServiceResult.AdditionalMapInfoList.map((item, index) => ({ ...item, ID: index + 1 }))}
								customHeaders={{
									"ID": "ردیف",
									"AdditionalMapTitle": "SH4604",
									"AdditionalMapMeasurement": "SH4605",
								}}		
							/>								
						</Tab>
						<Tab eventKey="tableMap" title="جدول بنای نقشه">
							<GridControl
								data={Object.keys(getServiceResult).length > 0 && getServiceResult.MapInfoList}
								customHeaders={{
									"FloorTitle": "طبقه",
									"PrimaryUsedTitle": "نوع استفاده اصلی",
									"SecondaryUsedTitle": "نوع استفاده فرعی",
									"Unit": "واحد",
									"Area": "مساحت",
									"EntryNumber": "تعداد دهانه",
									"EntryLength": "طول دهانه",
									"EntryHeight": "ارتفاع دهانه",
								}}		
							/>								
						</Tab>
					</Tabs>		
			
				</Accordion.Body>
			  </Accordion.Item>
			  <Accordion.Item eventKey="1">
				<Accordion.Header>دستور نقشه / تایید نقشه</Accordion.Header>
				<Accordion.Body>
					<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>					
						<tbody>
							<tr>
								<td><b class="b1">سطح اشغال زمین:</b> {getServiceResult.LandCoverLevel}</td>
								<td><b class="b1">سطح اشغال زمین:</b> {getServiceResult.AreaBuilding}</td>
								<td><b class="b1">محل احداث بنا (شمال):</b> {getServiceResult.BuildingPosition}</td>
							</tr>
							<tr>	
								<td><b class="b1">تعداد طبقات مجاز:</b> {getServiceResult.AllowedFloorCount}</td>
								<td colspan="2"><b class="b1">توضیحات دستور نقشه:</b> {getServiceResult.OrderMapDescription}</td>
							</tr>
						</tbody>
					</table>
					<br/>
					<GridControl
						data={Object.keys(getServiceResult).length > 0 && getServiceResult.OrderMapInfoList}
						customHeaders={{
							"FloorTitle": "طبقه",
							"PrimaryUsedTitle": "نوع استفاده اصلی",
							"SecondaryUsedTitle": "نوع استفاده فرعی",
							"Unit": "واحد",
							"Area": "مساحت",
							"EntryNumber": "تعداد دهانه",
							"EntryLength": "طول دهانه",
							"EntryHeight": "ارتفاع دهانه",
						}}		
					/>						
					<br/>
					<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>				
						<tbody>
								<tr>
									<td><b class="b1">تاریخ تایید نقشه:</b> {getServiceResult.ApprovalDate}</td>
									<td><b class="b1">تاریخ عدم تایید نقشه:</b> {getServiceResult.DisapprovalDate}</td>
									<td><b class="b1">توضیح عدم تایید:</b> {getServiceResult.DisapprovalMapDescription}</td>
								</tr>	
						</tbody>
					</table>					
				</Accordion.Body>
			  </Accordion.Item>	  
			</Accordion>			
        </div>
		:
			<div className="alert alert-danger text-center">موردی یافت نشد.</div>
		}
		</div>
    );
}
